<div class="mention-input">
    <input #inputRef type="text" [placeholder]="placeholder" [readonly]="readonly" [ngModel]="value" (ngModelChange)="onInput($event)"
        (keydown)="onKeydown($event)" (click)="updateSuggestions()" (blur)="onBlur()" autocomplete="off">
    <div class="mention-list" *ngIf="suggestions.length">
        <div class="mention-item" *ngFor="let user of suggestions; let i = index" [class.active]="i == activeIndex"
            fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
            (mousedown)="$event.preventDefault(); selectUser(user)" (mouseenter)="activeIndex = i">
            <span class="avatar">{{ user.avatar_text || initials(user.name) }}</span>
            <span class="name">{{ user.name }}</span>
        </div>
    </div>
</div>
